
export default {
  props: {
    review: {
      type: Object,
      default: () => {
        return {
          author: "Rémi - Webdesigner",
          text: "Je conçois des sites web performants et attractifs",
          img: "remi.png",
          alt: "Webdesigner ALEO",
        };
      },
    },

    isBgLogo: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getImageForBg() {
      const imgBg = this.$img("bg-experts.png", {
        format: "webp",
      });
      return {
        backgroundImage: `url('${imgBg}')`,
      };
    },
  },
};
